import { ChartAnswer } from "types";
import { LABS_DATE_TIME_QCODE } from "./constants";

const LABS_HEADER_QCODES = new Set([LABS_DATE_TIME_QCODE, "userId", "status"]);

function hasLabInterpretation(answers: ChartAnswer[]): boolean {
  return answers.some(
    ({ qCode, value }) =>
      (typeof value === "string" ? value.trim() !== "" : Boolean(value)) &&
      !LABS_HEADER_QCODES.has(qCode)
  );
}

export { hasLabInterpretation };
